<template>
	<div v-bind:id="item.Subtitle != '' ? item.Subtitle : 'panel_'+item.Id" class="card accordion bold-title widget">
				<button class="card-title accordion-title" aria-expanded="false">
					{{ item.Title }}
				</button>
				<section v-if="displaySummary" v-html="item.Summary" class="card-content accordion-content" v-bind:aria-labelledby="item.Title"></section>
	</div>
</template>

<script>
	export default {
		props: ['item', 'displaySummary'],
		components: {

		},
		mounted: function () {

		},
    }
</script>